<!--
    Program: ComMapMgmt.vue
    Author: SDL
    Description: 
    Created: 2020.03.13
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{pageTitle}}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->
            <div v-if="mode === 'search'">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w49">
                                <li class="tit_150">User ID</li>
                                <li data-input-type="select" class="w100-150">
                                    <select
                                        class="slt_white w100"
                                        v-model="searchParams.selectedUserId"
                                    >
                                        <option value="-">Select</option>
                                        <option
                                            v-for="item in searchableUserIdList"
                                            :key="item"
                                            :value="item"
                                        >{{item}}</option>
                                    </select>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                            </span>
                        </div>
                    </article>
                </div>
                <!--list table-->
                <div class="grid_wrap">
                    <!-- Grid Count-->
                    <div class="grid_total">
                        Total Count
                        <em>{{ resultCount | numberFormat }}</em>
                    </div>

                    <div class="btn_wrap">
                        <a
                            href="javascript:"
                            class="btn_blue"
                            title
                            @click="switchMode('create')"
                        >Create</a>
                    </div>
                    <div id="grid">
                        <toast-grid
                            gridId="gridComMapMgmt"
                            :key="gridKey"
                            :data="gridData"
                            :columns="gridColumns"
                            :options="gridOptions"
                            :pageOptions="gridPageOptions"
                            :theme="gridTheme"
                            :isTotalCount="false"
                            v-bind:click="selectGridItem"
                        />
                    </div>
                    <div class="paginate">
                        <sdl-pagination
                            :current-page="currentPage"
                            :total-rows="resultCount"
                            :per-page="perPage"
                            @change="search"
                            align="center"
                        />
                    </div>
                </div>
            </div>
            <!--list table-->
            <div v-else-if="mode === 'create'" class="grid_wrap">
                <!-- detail_f tit -->
                <div class="sub_tit mt25">Create New Com Map</div>
                <!-- //detail_f tit -->
                <table class="grid_table">
                    <colgroup>
                        <col width="150" />
                        <col width="*" />
                        <col width="150" />
                        <col width="*" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>User ID
                                <em class="txt_mandatory">*</em>
                            </th>
                            <td>
                                <select
                                    name="createUserIdList"
                                    class="slt_white w100"
                                    v-model="createParams.selectedUserId"
                                    @change="fetchSubCountryList"
                                >
                                    <option value="-">Select</option>
                                    <option
                                        v-for="item in createParams.userIdList"
                                        :key="item"
                                        :value="item"
                                    >{{item}}</option>
                                </select>
                            </td>
                            <th>Sub Country
                                <em class="txt_mandatory">*</em>
                            </th>
                            <td>
                                <select
                                    name="createStdCountryList"
                                    class="slt_white w100"
                                    v-model="createParams.selectedSubCountry"
                                >
                                    <option value="-">Select</option>
                                    <option
                                        v-for="item in createParams.subCountryList"
                                        :key="item"
                                        :value="item"
                                    >{{item}}</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!--//COPY detail_table-->
                <!-- page btn -->
                <div class="btn_wrap_full">
                    <a
                        href="javascript:"
                        class="btn_white size_full"
                        @click="switchMode('search')"
                    >{{ $t('BUTTON.GLOBAL.LIST') }}</a>

                    <div class="btn_right">
                        <!-- <a href="JavaScript:" class="btn_white" title>Save</a
                        >New버튼 클릭시-->
                        <a href="javascript:" class="btn_white" title @click="createItem()">Create</a>
                    </div>
                </div>
                <!-- //page btn -->
            </div>
        </div>
    </div>
</template>

<script>
import Vue   from 'vue';
import axios from 'axios';

import qs from 'query-string';

import { SDLUtil, StringUtil } from '@/utils';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

const MODULE_NAME = 'HHP ComMapMgmt B2B';
const MODULE_URL = `basis/anysvcmobile/comMapMgmt`;

// Toast Grid Custom Renderer
class CustomButtonRenderer {
    constructor(props) {
        const el = document.createElement('a');
        el.classList.add('btn_sm_white');
        const { text } = props.columnInfo.renderer.options;
        el.innerText = text;
        el.href = 'javascript:';
        this.el = el;
    }

    getElement() {
        return this.el;
    }
}

export default {
    name: 'hhp-com-map-mgmt-b2b',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    props: [],
    computed: {},
    data() {
        return {
            pageTitle: '',

            mode: 'search', // 'search', 'create'

            searchableUserIdList: [],

            searchParams: {
                selectedUserId: '-',
            },

            createParams: {
                userIdList: [],
                subCountryList: [],
                selectedUserId: '-',
                selectedSubCountry: '-',
            },

            selectedItem: {
                userId: '',
                subCountry: '',
            },

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,

            gridData: [],
            gridColumns: [
                {
                    header: 'User ID',
                    name: 'STD_COUNTRY',
                    align: 'center',
                    width: 220,
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Sub Country',
                    name: 'SUB_COUNTRY',
                    align: 'center',
                    width: 140,
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Reg User ID',
                    name: 'REG_USER_ID',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Reg Date',
                    name: 'REG_DATE',
                    width: 180,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: ' ',
                    name: 'Delete',
                    align: 'center',
                    width: 140,
                    renderer: { type: CustomButtonRenderer, options: { text: 'Delete' } },
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },
    created() {
        console.log('Component: hhp-com-map-mgmt-b2b created. ');
        this.loadSearchUserIdList();
        // this.search(1);
    },
    mounted() {
        console.log('Component: hhp-com-map-mgmt-b2b mounted. ');
    },
    methods: {
        loadSearchUserIdList() {
            SDLUtil.showLoadingBar(true);
            return axios
                .get(`${SDLUtil.API_URL}/${MODULE_URL}/ComMapMgmt.skp?b2b=y`)
                .then(res => {
                    console.log('ComMapMgmtB2B RESP', res);
                    // Update UserId List
                    this.searchableUserIdList = res.data.countryList.map(item => item.COUNTRY);
                    // Update UserId List for Create as well
                    this.createParams = Object.assign(
                        {},
                        {
                            userIdList: res.data.insertStdCountryList.map(item => item.STDCOUNTRY),
                            subCountryList: [],
                            selectedUserId: '-',
                            selectedSubCountry: '-',
                        },
                    );
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    // Vue.$log.error("ComMapMgmt",err);
                    if (
                        typeof err.data !== 'undefined' &&
                        typeof err.data.error !== 'undefined' &&
                        err.data.error.code === '403'
                    ) {
                        return axios
                            .get(`${SDLUtil.API_URL}${err.data.error.message}`)
                            .then(resp => {
                                console.log(resp);
                                this.loadSearchUserIdList().then(resp => {
                                    SDLUtil.showLoadingBar(false);
                                });
                                return resp;
                            })
                            .catch(err => {
                                Vue.$log.error(err);
                                SDLUtil.showLoadingBar(false);
                            });
                    }
                    SDLUtil.showLoadingBar(false);
                });
        },
        fetchSubCountryList() {
            this.createParams.selectedSubCountry = '-';
            this.createParams.subCountryList = [];

            SDLUtil.showLoadingBar(true);
            return axios
                .get(`${SDLUtil.API_URL}/${MODULE_URL}/selectSubCountryList.skp?b2b=y`, {
                    params: {
                        country: this.createParams.selectedUserId,
                    },
                })
                .then(res => {
                    console.log('ComMapMgmtB2B RESP', res);
                    this.createParams.subCountryList = res.data.subCountryList.map(item => item.SUBCOUNTRY);
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        search(pageNo) {
            if (!pageNo) pageNo = 1;

            const formData = {
                page: pageNo,
                country: this.searchParams.selectedUserId, // Though it's a user id, param name must be country.
            };

            if (formData.country === '-') {
                SDLUtil.alert({
                    msg: 'Please select a User ID.',
                });
                return;
            }

            return axios
                .post(`${SDLUtil.API_URL}/${MODULE_URL}/ComMapMgmtSearch.skp?b2b=y`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    console.log('SEARCH RESULT =>> ', resp);
                    this.resultCount = resp.data.count;
                    this.gridData = Object.assign([], resp.data.rows);

                    // Server에서 결과가 10개 미만일 때 항상 10을 돌려주는 문제를 임시적으로 해결하는 if문
                    if (
                        this.resultCount === 10 &&
                        typeof resp.data.rows !== 'undefined' &&
                        resp.data.rows.length < 10
                    ) {
                        this.resultCount = resp.data.rows.length;
                    }

                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        selectGridItem(e, rows) {
            console.log('selectGridItem', e, rows);
            this.selectedItem = {
                userId: rows[e.rowKey].STD_COUNTRY,
                subCountry: rows[e.rowKey].SUB_COUNTRY,
            };
            if (e.columnName === 'Delete') {
                this.deleteItem();
            }
            // window.scrollTo(0, 1000);
        },
        createItem() {
            const params = {
                stdcountry: this.createParams.selectedUserId,
                subcountry: this.createParams.selectedSubCountry,
            };

            if (params.stdcountry === '-') {
                return SDLUtil.alert({ msg: 'Please select User ID' });
            }
            if (params.subcountry === '-') {
                return SDLUtil.alert({ msg: 'Please select Sub Country' });
            }

            return axios
                .post(`${SDLUtil.API_URL}/${MODULE_URL}/InsertComMapList.skp?b2b=y`, qs.stringify(params), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    console.log('INSERT', res);
                    if (res.data.result === '0') {
                        SDLUtil.alert({
                            msg: `ComMap Created!<br>User ID: <strong>${params.stdcountry}</strong><br>Sub Country: <strong>${params.subcountry}</strong>`,
                            onOkEvt: () => {
                                this.mode = 'search';
                                this.createParams.selectedUserId = '-';
                                this.createParams.selectedSubCountry = '-';
                                this.searchParams.selectedUserId = params.stdcountry;
                                this.search(1);
                            },
                        });
                    } else {
                        SDLUtil.alert({ msg: 'Failed to create code!', onOkEvt: () => {} });
                    }
                })
                .catch(err => {
                    Vue.$log.error('INSERT', err);
                    SDLUtil.alert({ msg: 'Failed to create code!', onOkEvt: () => {} });
                });
        },
        deleteItem() {
            // this.selectedItem
            const params = {
                stdcountry: this.selectedItem.userId,
                subcountry: this.selectedItem.subCountry,
            };
            return SDLUtil.confirm({
                title: 'Delete ComMap?',
                msg: `Would you like to delete the ComMap?<br>User ID: <strong>${params.stdcountry}</strong><br>Sub Country: <strong>${params.subcountry}</strong>`,
                okLabel: 'Delete',
                onOkEvt: () => {
                    return axios
                        .post(`${SDLUtil.API_URL}/${MODULE_URL}/DeleteComMapList.skp?b2b=y`, qs.stringify(params), {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                        })
                        .then(res => {
                            console.log('DELETE', res);
                            if (res.data.result > 0) {
                                // Success
                                SDLUtil.alert({
                                    msg: `ComMap Deleted!<br>User ID: <strong>${params.stdcountry}</strong><br>Sub Country: <strong>${params.subcountry}</strong>`,
                                });
                                this.search(this.currentPage);
                                this.selectedItem = {
                                    stdCountry: '',
                                    subCountry: '',
                                };
                            } else {
                                SDLUtil.alert({ msg: 'Failed to delete ComMap!' });
                            }
                        })
                        .catch(err => {
                            Vue.$log.error('DELETE', err);
                            SDLUtil.alert({ msg: 'Failed to delete ComMap!' });
                        });
                },
            });
        },
        switchMode(mode) {
            window.scrollTo(0, 0);
            this.mode = mode;
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/comMapMgmt/ComMapMgmtB2B.vue